export default __webpack_public_path__ + "static/cmp@2x-ae3e2261d7067148a45b4ffb71f5dcac.png";